import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetPresetsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetPresetsQuery = { __typename?: 'Query', getExportPresets: Array<{ __typename?: 'PremiereExportPreset', name: string, id: string, isFavorite?: boolean | null, isCustom?: boolean | null, format: string } | null> };


export const GetPresets = /*#__PURE__*/ gql`
    query GetPresets {
  getExportPresets {
    name
    id
    isFavorite
    isCustom
    format
  }
}
    ` as unknown as DocumentNode<GetPresetsQuery, GetPresetsQueryVariables>;

          

          export const useGetPresetsQuery = (options?:QueryHookOptions<GetPresetsQuery, GetPresetsQueryVariables>) => useQuery(GetPresets, options);

          

          export type GetPresetsQueryOptions = QueryHookOptions<GetPresetsQuery, GetPresetsQueryVariables>;

          

          export const useGetPresetsLazyQuery = (options?:LazyQueryHookOptions<GetPresetsQuery, GetPresetsQueryVariables>) => useLazyQuery(GetPresets, options);

          

          export type GetPresetsQueryResult = ReturnType<typeof useGetPresetsQuery>;

          
